import styled from 'styled-components';
import StopLoad from './StopLoad';

export default styled(StopLoad)`
  display: flex;

  .stop-load {
    display: flex;
    justify-content: space-between;
    width: 100%;

    &--aggregated {
      margin-bottom: 0.8rem;
      padding-left: 24px;
    }

    &__load-detail {
      align-items: center;
      display: flex;
      justify-content: space-between;
      width: 175px;
    }
    &__summary,
    &__custom-size {
      margin-right: 0.8rem;
    }

    &__weight {
      color: var(--grey700);
    }

    &__inspect {
    }
  }
`;
